import AppMenubarChildItem from '@/components/AppMenu/AppMenubarChildItem';
import type { MenuNavigation } from '@/models/types';
import { useUserPermissions } from '@/shared/auth/useUserAffectations';
import { Burger, Menu } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { useState } from 'react';

type Props = {
  items: MenuNavigation[];
};

const AppMenuBurger = ({ items }: Props) => {
  const { t } = useTranslate();
  const { permissions: userPermissions, isLoading } = useUserPermissions();
  const [opened, setOpened] = useState(false);

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      transitionProps={{ transition: 'pop-top-left' }}
      offset={2}
    >
      <Menu.Target>
        <Burger
          opened={opened}
          size="sm"
          aria-label={t('header.navigation_menu')}
          disabled={isLoading}
        />
      </Menu.Target>
      <Menu.Dropdown miw={240}>
        {items.map(item => (
          <AppMenubarChildItem key={item.id} item={item} userPermissions={userPermissions} />
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default AppMenuBurger;
